export const translations = {
  pt: {
    nav: {
      services: 'Serviços',
      about: 'Sobre Nós',
      contact: 'Contactos',
      getQuote: 'Orçamento Gratuito'
    },
    hero: {
      title: 'Contabilidade e Fiscalidade para Empresas e Particulares',
      subtitle: 'Apoio contabilístico e fiscal com clareza, rigor e experiência.',
      cta: 'Orçamento Gratuito'
    },
    services: {
      title: 'Os Nossos Serviços',
      subtitle: 'Soluções completas de contabilidade e fiscalidade para o seu negócio',
      items: [
        {
          id: 1,
          title: 'Processamento de Salários',
          description: 'Gestão completa de vencimentos, incluindo cálculo de impostos, contribuições e emissão de recibos.'
        },
        {
          id: 2,
          title: 'Relatórios Periódicos',
          description: 'Relatórios financeiros claros e detalhados para acompanhar a saúde do seu negócio.'
        },
        {
          id: 3,
          title: 'Apoio Fiscal',
          description: 'Planeamento e otimização fiscal para maximizar os benefícios da sua empresa.'
        },
        {
          id: 4,
          title: 'Abertura de Empresas',
          description: 'Acompanhamento completo no processo de constituição e legalização de empresas.'
        },
        {
          id: 5,
          title: 'Gestão de Recursos Humanos',
          description: 'Apoio na gestão administrativa de colaboradores, contratos e obrigações legais.'
        },
        {
          id: 6,
          title: 'Apoio a Expatriados',
          description: 'Serviços especializados para estrangeiros que pretendem trabalhar ou investir em Portugal.'
        },
        {
          id: 7,
          title: 'Subsídios e Incentivos',
          description: 'Identificação e candidatura a apoios e incentivos do Estado para o seu negócio.'
        }
      ]
    },
    audience: {
      title: 'Para Quem Trabalhamos',
      subtitle: 'Soluções adaptadas a diferentes perfis e necessidades',
      items: [
        {
          id: 1,
          title: 'Pequenas e Médias Empresas',
          description: 'Apoio completo para PMEs que procuram crescer de forma sustentável.'
        },
        {
          id: 2,
          title: 'Empresários em Nome Individual',
          description: 'Serviços personalizados para trabalhadores independentes e freelancers.'
        },
        {
          id: 3,
          title: 'Particulares',
          description: 'Apoio fiscal e declarações de IRS para pessoas singulares.'
        },
        {
          id: 4,
          title: 'Expatriados',
          description: 'Orientação especializada para estrangeiros em Portugal.'
        }
      ]
    },
    about: {
      title: 'Somos Nós',
      subtitle: 'Conheça a nossa equipa e valores',
      description: 'Com mais de 20 anos de experiência no mercado, a nossa equipa está preparada para oferecer soluções contabilísticas e fiscais à medida das suas necessidades.',
      highlights: [
        'Mais de 20 anos de experiência na área',
        'Equipa com vasta experiência no mercado',
        'Acompanhamento próximo e rigoroso',
        'Relatórios claros e previsões de impostos',
        'Soluções adaptadas a cada cliente',
        'Preços competitivos'
      ]
    },
    contact: {
      title: 'Contacte-nos',
      subtitle: 'Estamos aqui para ajudar. Entre em contacto connosco.',
      form: {
        name: 'Nome',
        email: 'Email',
        phone: 'Telefone',
        message: 'Mensagem',
        submit: 'Pedir Orçamento Gratuito',
        success: 'Mensagem enviada com sucesso!',
        namePlaceholder: 'O seu nome',
        emailPlaceholder: 'o.seu@email.com',
        phonePlaceholder: '912 345 678',
        messagePlaceholder: 'Como podemos ajudar?'
      },
      info: {
        phone: '911 000 000',
        address: 'Rua Prudêncio Franco da Trindade 4, 2655-344 Ericeira',
        hours: 'Segunda a Sexta, das 9h às 18h'
      }
    },
    footer: {
      company: 'Contabilidade e Fiscalidade, Lda',
      tagline: 'Clareza, rigor e experiência ao serviço do seu negócio.',
      services: 'Serviços',
      contact: 'Contactos',
      languages: 'Idiomas',
      rights: 'Todos os direitos reservados.'
    }
  },
  en: {
    nav: {
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
      getQuote: 'Free Quote'
    },
    hero: {
      title: 'Accounting and Tax Services for Businesses and Individuals',
      subtitle: 'Accounting and tax support with clarity, rigor, and experience.',
      cta: 'Free Quote'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete accounting and tax solutions for your business',
      items: [
        {
          id: 1,
          title: 'Payroll Processing',
          description: 'Complete salary management, including tax calculations, contributions, and payslip issuance.'
        },
        {
          id: 2,
          title: 'Periodic Reports',
          description: 'Clear and detailed financial reports to monitor your business health.'
        },
        {
          id: 3,
          title: 'Tax Support',
          description: 'Tax planning and optimization to maximize your company benefits.'
        },
        {
          id: 4,
          title: 'Company Formation',
          description: 'Complete guidance in the process of establishing and legalizing companies.'
        },
        {
          id: 5,
          title: 'HR Management',
          description: 'Support in administrative management of employees, contracts, and legal obligations.'
        },
        {
          id: 6,
          title: 'Expatriate Support',
          description: 'Specialized services for foreigners who wish to work or invest in Portugal.'
        },
        {
          id: 7,
          title: 'Subsidies and Incentives',
          description: 'Identification and application for state support and incentives for your business.'
        }
      ]
    },
    audience: {
      title: 'Who We Work With',
      subtitle: 'Solutions adapted to different profiles and needs',
      items: [
        {
          id: 1,
          title: 'Small and Medium Enterprises',
          description: 'Complete support for SMEs looking to grow sustainably.'
        },
        {
          id: 2,
          title: 'Sole Proprietors',
          description: 'Personalized services for self-employed and freelancers.'
        },
        {
          id: 3,
          title: 'Individuals',
          description: 'Tax support and income tax returns for individuals.'
        },
        {
          id: 4,
          title: 'Expatriates',
          description: 'Specialized guidance for foreigners in Portugal.'
        }
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'Meet our team and values',
      description: 'With over 20 years of market experience, our team is prepared to offer accounting and tax solutions tailored to your needs.',
      highlights: [
        'Over 20 years of experience',
        'Team with vast market experience',
        'Close and rigorous monitoring',
        'Clear reports and tax forecasts',
        'Solutions adapted to each client',
        'Competitive prices'
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help. Get in touch with us.',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Request Free Quote',
        success: 'Message sent successfully!',
        namePlaceholder: 'Your name',
        emailPlaceholder: 'your@email.com',
        phonePlaceholder: '912 345 678',
        messagePlaceholder: 'How can we help?'
      },
      info: {
        phone: '911 000 000',
        address: 'Rua Prudêncio Franco da Trindade 4, 2655-344 Ericeira',
        hours: 'Monday to Friday, 9am to 6pm'
      }
    },
    footer: {
      company: 'Contabilidade e Fiscalidade, Lda',
      tagline: 'Clarity, rigor, and experience at the service of your business.',
      services: 'Services',
      contact: 'Contact',
      languages: 'Languages',
      rights: 'All rights reserved.'
    }
  }
};

export const serviceIcons = [
  'Wallet',
  'FileText',
  'Calculator',
  'Building2',
  'Users',
  'Globe',
  'Award'
];

export const audienceIcons = [
  'Building',
  'User',
  'UserCircle',
  'Plane'
];
